import { Component, inject, signal } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../services/auth.service';

@Component({
    selector: 'app-login',
    imports: [FormsModule],
    templateUrl: './login.component.html'
})
export class LoginComponent {
  private auth = inject(AuthService);

  username = '';
  password = '';
  rememberMe = false;

  busy = signal(false);
  error = signal<string | null>(null);

  /** No accounts exist yet — nobody can get in from outside until one is created at home. */
  noUsers = () => this.auth.userCount() === 0;

  submit() {
    if (this.busy()) return;
    const username = this.username.trim();
    if (!username || !this.password) {
      this.error.set('Bitte Benutzername und Kennwort eingeben.');
      return;
    }

    this.busy.set(true);
    this.error.set(null);

    this.auth.login(username, this.password, this.rememberMe).subscribe({
      next: () => {
        this.password = '';
        this.auth.loadSession().subscribe({
          next: () => this.busy.set(false),
          error: () => this.busy.set(false),
        });
      },
      error: (err: HttpErrorResponse) => {
        this.busy.set(false);
        this.password = '';
        if (err.status === 429) {
          const seconds = err.error?.retryAfterSeconds ?? 0;
          const minutes = Math.max(1, Math.ceil(seconds / 60));
          this.error.set(
            `Zu viele Fehlversuche. Bitte in etwa ${minutes} Minute(n) erneut versuchen.`,
          );
        } else if (err.status === 401) {
          this.error.set('Benutzername oder Kennwort ist falsch.');
        } else {
          this.error.set('Anmeldung fehlgeschlagen. Bitte später erneut versuchen.');
        }
      },
    });
  }
}
